module.exports = __webpack_public_path__ + "static/media/Filter_Major_LubeFilter_Xparent.aa78cdc0.png";